<template>
  <div class="status-page">
    <div class="mobile-view" v-if="showLevelNames">
      <div class="mobile-levelnames">
        <div class="levels-name">
          <svg v-if="currentLevel.level === 0"><use xlink:href="#mobile-par3"></use></svg>
          <svg v-else><use xlink:href="#par3-level-success"></use></svg>
        </div>
        <div class="levels-name">
          <svg v-if="currentLevel.level === 0"><use xlink:href="#mobile-par4"></use></svg>
          <svg v-if="currentLevel.level === 1"><use xlink:href="#mobile-secondlevel-yellow"></use></svg>
          <svg v-if="currentLevel.level === 2 || currentLevel.level === 3"><use xlink:href="#par4-level-success"></use></svg>
        </div>
        <div class="levels-name">             
          <svg v-if="currentLevel.level === 2"><use xlink:href="#mobile-thirdlevel-yellow"></use></svg>
          <svg v-if="currentLevel.level === 3"><use xlink:href="#par5-level-success"></use></svg>
          <svg v-if="currentLevel.level === 0 || currentLevel.level === 1"><use xlink:href="#mobile-par5"></use></svg>
        </div>
        <div class="levels-name regluvardar">
          <svg><use xlink:href="#mobile-regluvardar"></use></svg>
        </div>
      </div>
    </div>
    <div v-for="(answer, index) in answerSheet" :key="index" 
    :class="['status-bar-inner', answer !== null ? answer.toString(): '']">
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusBar',
  props: ['answerSheet', 'primeLevel', 'currentLevel', 'showLevelNames'],
  // data () {
  //   return {
  //     answerInfo: null
  //   }
  // }
}
</script>

<style lang="scss" scoped>
  .status-page {
    position: relative;
    &.status-bar-wrap-prime {
      // display: none;
    }
  }
  .status-bar-inner {
    width: 13px;
    display: inline-block;
    margin: 0.4rem;
    height: 13px;
    border-radius: 50%;
    background-color: #C4C4C4;
    &.true {
      background-color: #2EC4B6;
    }
    &.false {
      background-color: #FF6A6A;
    }
    &.current {
      background: #FCBD00;
    }
  }
.footer-text {
  padding: 15px;
  font-size: 13px;
  color: #000000;
  text-align: center;
}
.mobile-levelnames {
  // position: absolute;
  // top: -6rem;
  position: fixed;
  top: -10px;
  left: 85px;
  padding: 16px 6px 1px;
  z-index: 999999;
}
@media (max-width: 768px) {
  .status-page {
    &.status-bar-wrap-prime {
      .mobile-levelnames {
        display: none;
      }
    }
  }
  .status-bar-wrap-prime {
    .status-bar-inner {
      display: none;
    }
  }
}
</style>
